import styled, { css } from 'styled-components';

import BootstrapModal from 'react-bootstrap/Modal';

export const StyledModal = styled(BootstrapModal)`
  background-color: rgba(51, 51, 51, 0.6);
  z-index: 10003 !important;

  && .modal-header {
    align-items: center;
  }

  && .modal-title {
    flex: 1;
    min-width: 0;
  }
`;

export const StyledModalBody = styled(BootstrapModal.Body)``;
